interface Colors {
  backgroundLight: string;
  background: string;
  backgroundDark: string;
  text: string;
  textMuted: string;
  border: string;
  
  primary: string;
  primaryContrastText: string;
  secondary: string;
  secondaryContrastText: string;

  danger: string;
  dangerText: string;
  dangerBackground: string;

  warning: string;
  warningBackground: string;
  warningText: string;

  success: string;
  successBackground: string;
  successText: string;

  info: string;
  infoBackground: string;
  infoText: string;

  pickableColors: string[];
}

const colors: Colors = {
  backgroundLight: "hsl(220 0% 100%)",
  background: "hsl(220 0% 97%)",
  backgroundDark: "hsl(220 0% 91%)",
  text: "hsl(226 85% 7%)",
  textMuted: "hsl(220 26% 31%)",
  border: "hsl(220 19% 85%)",

  primary: "#006EEA",
  primaryContrastText: "#ffffff",
  secondary: "#9D7EE5",
  secondaryContrastText: "#ffffff",

  danger: "#EB5757",
  dangerBackground: "#FDEBEB",
  dangerText: "#B42318",

  warning: "#F2C94C",
  warningBackground: "#FFFAEB",
  warningText: "#7A6200",

  success: "#27AE60",
  successBackground: "#e6f9eb",
  successText: "#1E824C",

  info: "#2F80ED",
  infoBackground: "#f2f8ff",
  infoText: "#2F80ED",

  pickableColors: [
    "#ffffcc",
    "#ffcc99",
    "#ffcccc",
    "#ff99cc",
    "#ffccff",
    "#cc99ff",
    "#ccccff",
    "#99ccff",
    "#ccffff",
    "#99ffcc",
    "#ccffcc",
    "#ccff99",
  ],
};

export default colors;

